<a
  [routerLink]="routerLink"
  [title]="'View' | translate"
  class="info ml-1 mr-1 font-medium-2"
><i class="ft-eye"></i></a>
